import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'

const menu = [
    { label: "About Us", link: "/#about" },
    { label: "Events", link: "/#events" },
    { label: "Membership", link: "/#membership" },
    { label: "Contribute", link: "/#contribute" },
    { label: "Gallery", link: "/#gallery" },
    { label: "Contact Us", link: "/#contact-us" },
];

function Header() {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    // Doosre page se hash URL par aane par automatically smooth scroll karega
    useEffect(() => {
        if (location.hash) {
            const hashId = location.hash.replace("#", "");
            const element = document.getElementById(hashId);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    // Custom function jo hash par smoothly scroll karega
    const handleNavClick = (e, path) => {
        setIsOpen(false); // Mobile menu close karne ke liye

        if (path.includes("#")) {
            const hash = path.split("#")[1];
            const element = document.getElementById(hash);

            // Agar hum already Home page ("/") par hain
            if (location.pathname === "/") {
                e.preventDefault(); // Default jump roko
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                    window.history.pushState(null, "", `#${hash}`); // URL me hash update karo bina jump kiye
                }
            }
            // Agar kisi aur page par hain toh React Router automatically navigate karega
        } else if (path === "/") {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const handleRegisterClick = () => {
        const formLink = "https://forms.gle/LYgBKQ6RYsr7riRHA";
        window.open(formLink, "_blank", "noopener,noreferrer");
    };

    const handleLogoClick = () => {
        navigate("/");
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <>
            <div className='z-[100] left-0 fixed bg-[#FFFFFF] top-0 w-full' style={{ boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.22)" }}>
                <div className="flex justify-end max-w-[1280px] w-full mx-auto gap-[20px] pt-[20px]">
                    <button
                        onClick={handleRegisterClick}
                        className="hover:text-white uppercase hover:bg-[#08717D] text-[16px] font-[600] font-manrope border border-[#08717D] rounded-[6px] px-[20px] py-[8px] bg-white text-primary transition-all duration-300">
                        Register
                    </button>
                    <a href="#join-now" onClick={(e) => handleNavClick(e, "/#membership")}>
                        <button
                            className="hover:text-white uppercase hover:bg-[#08717D] text-[16px] font-[600] font-manrope border border-[#08717D] rounded-[6px] px-[20px] py-[8px] bg-white text-primary transition-all duration-300">
                            Become A Member
                        </button>
                    </a>
                    <button
                        className="hover:text-white uppercase hover:bg-[#08717D] text-[16px] font-[600] font-manrope border border-[#08717D] rounded-[6px] px-[20px] py-[8px] bg-white text-primary transition-all duration-300">
                        Donate
                    </button>
                </div>

                <div className='max-w-[1280px] w-full mx-auto'>
                    <div className='flex justify-between bg-[#FFFFFF] items-center lg:px-[0px] px-[20px] lg:py-[8px] py-[10px]'>
                        <Link onClick={handleLogoClick} to="/">
                            <img src="/assets/nav/logo.png" className='lg:h-[57px] h-[41.1094px] object-cover' alt="Logo" />
                        </Link>
                        
                        <div className='hidden lg:flex gap-[20px] items-center'>
                            <div className="flex items-center gap-[40px]">
                                {menu?.map((e, i) => (
                                    <Link
                                        to={e?.link}
                                        key={i}
                                        onClick={(event) => handleNavClick(event, e?.link)}
                                        className='font-[500] font-manrope text-[16px] leading-[26px] text-[#222222] hover:text-[#08717D] transition-colors'
                                    >
                                        {e?.label}
                                    </Link>
                                ))}
                            </div>
                        </div>

                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="lg:hidden flex flex-col gap-[5px] focus:outline-none"
                        >
                            <span className="w-6 h-[2px] bg-black"></span>
                            <span className="w-6 h-[2px] bg-black"></span>
                            <span className="w-6 h-[2px] bg-black"></span>
                        </button>
                    </div>
                </div>

                {/* Mobile Menu */}
                {isOpen && (
                    <ul className="lg:hidden bg-white shadow-md px-[20px] py-[15px] flex flex-col gap-[20px]">
                        {menu?.map((e, i) => (
                            <li key={i}>
                                <Link
                                    to={e?.link}
                                    onClick={(event) => handleNavClick(event, e?.link)}
                                    className="font-[500] font-manrope text-[16px] text-[#222]"
                                >
                                    {e?.label}
                                </Link>
                            </li>
                        ))}
                        <button className="flex items-center gap-2">
                            <img src="/assets/nav/search.svg" alt="search" />
                            <span className="text-[#222]">Search</span>
                        </button>
                    </ul>
                )}
            </div>
        </>
    )
}

export default Header